// Generated by ReScript, PLEASE EDIT WITH CARE


var redirect = (function(url) {
    return window.location.href=url;
  });

var replace = (function(url) {
    return window.location.replace(url);
  });

var addClass = (function(elem, class_name) {
    return elem.classList.add(class_name)
  });

var removeClass = (function(elem, class_name) {
    return elem.classList.remove(class_name)
  });

var offsetHeight = (function(ele) {
    return ele.offsetHeight
  });

var $$Document = {};

var $$IntersectionObserver = {};

export {
  redirect ,
  replace ,
  addClass ,
  removeClass ,
  offsetHeight ,
  $$Document ,
  $$IntersectionObserver ,
  
}
/* No side effect */
